import React, { useState, useRef } from 'react';
import { RevealUp } from './ScrollReveal';

const ProfilePicture = ({ 
  profilePicture, 
  name, 
  onUpload, 
  onRemove, 
  size = 'large',
  editable = true 
}) => {
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const sizeClasses = {
    small: 'w-12 h-12',
    medium: 'w-20 h-20',
    large: 'w-32 h-32',
    xlarge: 'w-48 h-48'
  };

  const handleFileSelect = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('कृपया एक वैध छवि फ़ाइल चुनें');
      return;
    }

    // Validate file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('फ़ाइल का आकार 5MB से कम होना चाहिए');
      return;
    }

    setIsUploading(true);
    try {
      await onUpload(file);
    } catch (error) {
      console.error('Upload error:', error);
      alert('छवि अपलोड करने में त्रुटि हुई');
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemove = async () => {
    if (window.confirm('क्या आप वाकई अपनी प्रोफ़ाइल फ़ोटो हटाना चाहते हैं?')) {
      try {
        await onRemove();
      } catch (error) {
        console.error('Remove error:', error);
        alert('फ़ोटो हटाने में त्रुटि हुई');
      }
    }
  };

  const getInitials = (name) => {
    return name
      ? name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
      : 'U';
  };

  return (
    <RevealUp className="flex flex-col items-center space-y-4">
      <div className="relative group">
        <div className={`${sizeClasses[size]} rounded-full overflow-hidden border-4 border-temple-primary/20 shadow-temple-md bg-gradient-to-br from-temple-primary/10 to-temple-secondary/10 flex items-center justify-center`}>
          {profilePicture ? (
            <img
              src={`${process.env.REACT_APP_API_URL || 'https://phulhar-dham.onrender.com'}${profilePicture}`}
              alt={name}
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`font-serif font-bold text-temple-primary ${
              size === 'small' ? 'text-sm' : 
              size === 'medium' ? 'text-lg' : 
              size === 'large' ? 'text-2xl' : 'text-4xl'
            }`}>
              {getInitials(name)}
            </span>
          )}
        </div>

        {editable && (
          <div className="absolute inset-0 rounded-full bg-black/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
            <div className="flex space-x-2">
              <button
                onClick={() => fileInputRef.current?.click()}
                disabled={isUploading}
                className="p-2 bg-temple-primary text-white rounded-full hover:bg-temple-primary-dark transition-colors disabled:opacity-50"
                title="फ़ोटो बदलें"
              >
                {isUploading ? (
                  <i className="fas fa-spinner fa-spin text-sm"></i>
                ) : (
                  <i className="fas fa-camera text-sm"></i>
                )}
              </button>
              
              {profilePicture && (
                <button
                  onClick={handleRemove}
                  className="p-2 bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors"
                  title="फ़ोटो हटाएं"
                >
                  <i className="fas fa-trash text-sm"></i>
                </button>
              )}
            </div>
          </div>
        )}

        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileSelect}
          className="hidden"
        />
      </div>

      {editable && (
        <div className="text-center">
          <p className="text-sm text-temple-text-muted">
            फ़ोटो बदलने के लिए क्लिक करें
          </p>
          <p className="text-xs text-temple-text-muted mt-1">
            अधिकतम आकार: 5MB
          </p>
        </div>
      )}
    </RevealUp>
  );
};

export default ProfilePicture;